import type { FiltersLoadCapacityType, FiltersUnloadCapacityType } from "./types";

export const gridParameterizationType = {
  UnloadCapacity: "unload-capacity",
  LoadCapacity: "load-capacity"
}

export const unloadCapacityRadioValues = {
  materialGroup: "materialGroup",
  family: "family",
};

export const filtersLoadCapacityDefault: FiltersLoadCapacityType = {
  businessUnitId: undefined,
  supplierId: undefined,
};

export const filtersUnloadCapacityDefault: FiltersUnloadCapacityType = {
  businessUnitId: undefined,
  materialGroupId: undefined,
  familyId: undefined,
};

export const isFilterSelected = (
  type: string,
  filtersLoadCapacity: FiltersLoadCapacityType,
  filtersUnloadCapacity: FiltersUnloadCapacityType,
  selectedRadioUnloadCapacity: string
) => {
  if (
    type === gridParameterizationType.UnloadCapacity &&
    selectedRadioUnloadCapacity === unloadCapacityRadioValues.materialGroup
  ) {
    return filtersUnloadCapacity.businessUnitId && filtersUnloadCapacity.materialGroupId;
  } else if (
    type === gridParameterizationType.UnloadCapacity &&
    selectedRadioUnloadCapacity === unloadCapacityRadioValues.family
  ) {
    return filtersUnloadCapacity.businessUnitId && filtersUnloadCapacity.familyId;
  } else if (type === gridParameterizationType.LoadCapacity) {
    return filtersLoadCapacity.businessUnitId && filtersLoadCapacity.supplierId;
  }
};
